import { ParentSize } from '@visx/responsive';
import UsageBarChart from './UsageVisxBarChart';

export default function UsageBarChartWrapper({ data, ...props }) {
  return (
    <div className="w-full h-80 bg-bg-card rounded-lg border border-border-default p-spacing-4">
      <ParentSize>
        {({ width, height }) => (
          <UsageBarChart
            data={data}
            width={width}
            height={height}
            {...props}
          />
        )}
      </ParentSize>
    </div>
  );
}
